import {Command} from "./Command";
import {GamePlay} from "../model/game-play";

/**
 * Calcule la distance en fonction du gain et de la distance du jeu précédent
 */
export class CalculateDistanceCommand implements Command {
  constructor(
    private gamePlay: GamePlay,
    private lastGamePlay: GamePlay
  ) { }

  execute() {
    if (this.lastGamePlay.distance === undefined) {
      console.log('GamePlay sans distance. Aucun calcul de la distance')
      return
      // throw new Error('GamePlay sans distance')
    }
    if (this.lastGamePlay.gnLs === undefined) {
      throw new Error('GamePlay sans gnLs')
    }

    this.gamePlay.distance = this.lastGamePlay.distance - this.lastGamePlay.gnLs

    console.log('COMMAND CalculateDistanceCommand', this.gamePlay.distance)
  }
}
